import { z } from "zod";

export const ServiceActivityPartyItemSchema = z.object({
  id: z.string().uuid(),
  addressUsed: z.string().optional(),
  instanceTypeCode: z.number().optional(),
  roleCode: z.number().optional(),
  isPartyDeleted: z.boolean().optional(),
  partyTypeCode: z.number().optional(),
  activityId: z.string().uuid().optional(),
  partyId: z.string().uuid().optional(),
  partyName: z.string().optional(),
});

export type ServiceActivityPartyItemType = z.infer<
  typeof ServiceActivityPartyItemSchema
>;

export const ActivityPartyRole = {
  SENDER: 1,
  RESOURCE: 10,
  CUSTOMER: 11,
  TO: 2,
  CC: 3,
  BCC: 4,
  REQUIRED_ATTENDEE: 5,
  OPTIONAL_ATTENDEE: 6,
  ORGANIZER: 7,
  REGARDING: 8,
  OWNER: 9,
} as const;
